import { useEffect } from 'react';
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function LanguageRedirect() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const langMatch = path.match(/^\/(en|fr|da|de)\//);
    if (langMatch) {
      const lang = langMatch[1];
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }
  }, [location.pathname]);

  return null;
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <LanguageRedirect />
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;